import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';

import mobileAppLogo from 'assets/images/auth_confirm.jpg';

import Layout from 'Layout/Layout';

import { GOOGLE_PLAY_URL, APP_STORE_URL } from 'consts';

import appStore from 'assets/icons/app_store_badge.svg';
import googlePlay from 'assets/icons/google_play_badge.svg';
import { withLocale } from '@dietlabs/components';

class ConfirmPage extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
    };

    render() {
        return (
            <Layout page="diet">
                <section>
                    <Container>
                        <Row>
                            <Col xs="12" className="text-center">
                                <h1>{this.props.t('auth/confirm/header')}</h1>
                                <p>{this.props.t('auth/confirm/content')}</p>

                                <img
                                    className="img-fluid mb-4"
                                    src={mobileAppLogo}
                                    alt=""
                                />
                                <p>{this.props.t('auth/confirm/mobileApps')}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col
                                xs="12"
                                className="text-center authConfirm__apStoreLinks"
                            >
                                <a href={GOOGLE_PLAY_URL}>
                                    <img src={googlePlay} alt="Google Play" />
                                </a>

                                <a href={APP_STORE_URL}>
                                    <img src={appStore} alt="App store" />
                                </a>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Layout>
        );
    }
}

export default withLocale(ConfirmPage);
